/*
TME/TMA do RANKING baseado nos participantes
*/

import React, { useEffect } from 'react';
// import { HorizontalBar } from 'recharts';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, LabelList, ResponsiveContainer, Rectangle, Label, ReferenceLine } from 'recharts';
import { useState } from 'react';
import { api_bd_nr } from '../../services/Api';
import { msToTime } from '../../util/fns';



const CustomBarChart = ({
    chartData = [],
    CustomTick_XAxis,
    CustomTick_YAxis,
    CustomTooltip,
    barheight,
    renderCustomLabel,
    renderCustomBarLabelRight,
    renderCustomBarLabelLeft,
    prefix = 'TME: ',
    dataKey_X = 'tme',
    dataKey_Y = 'name',
    title = 'TME',
    cardHeight = 500,
    target = null
}) => {

    // chartData = chartData.sort((a, b) => b[dataKey_X] - a[dataKey_X])
    chartData = chartData?.length > 0
        ? [...chartData].sort((a, b) => b?.[dataKey_X] - a?.[dataKey_X]) // Create a copy before sorting
        : [];

    const formatTarget = (_hours) => {
        const hoursInMs = _hours * (60 * 60 * 1000)
        return ({ ms: hoursInMs, hours: _hours + ':00' })
    }


    const CustomReferenceLabel = ({ viewBox, label = '', color = "#ff0000", position = 'top' }) => {
        const { x, y, width, height } = viewBox;
        return (
            <g>
                <text style={{ fontSize: 10 }} fontWeight="bold" x={x - 10} y={position === 'top' ? (y + (height * 0.3)) : (y + (height * 0.7))} fill={color} textAnchor="end" dominantBaseline="middle">
                    {label}
                </text>
            </g>
        );
    };

    return (
        <div style={{ width: '100%', maxWidth: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
            <span style={{ marginTop: 20, marginBottom: 10, fontSize: '1.3em', fontWeight: 'bold' }}>{title}</span>
            <div style={{
                display: 'flex',
                width: '100%',
                height: cardHeight
            }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={chartData}
                        layout="vertical"
                        margin={{
                            top: 20,
                            right: 20,
                            // left: 90,
                            bottom: 5
                        }}
                        // barGap="-80%"
                        barGap={60}
                    >

                        {/* <CartesianGrid
                        // strokeDasharray="1 1" 
                        /> */}

                        <XAxis
                            type="number"
                            tick={CustomTick_XAxis}
                            dataKey={dataKey_X}
                            domain={[0, Math.max(chartData?.[0]?.[dataKey_X], (chartData?.[0]?.[`old_${dataKey_X}`] || chartData?.[0]?.[dataKey_X]))]}
                            stroke="#0c51dab4"
                        />
                        <YAxis
                            // axisLine={false}
                            tickLine={false}
                            dataKey={dataKey_Y}
                            type="category"
                            // tick={CustomTick_YAxis}
                            tickFormatter={() => ''}
                            stroke="#0c51dab4"
                        />
                        <Tooltip content={<CustomTooltip prefix={prefix} />} />

                        {/* barra com os dados atuais */}
                        <Bar
                            radius={[0, 5, 5, 0]}
                            dataKey={dataKey_X}
                            // barSize={barheight}
                            label={renderCustomBarLabelRight}
                        >
                            {chartData.map((entry, index) => (
                                //Configuração da barra
                                <Cell key={`cell-${index}`} fill="#0c51dab4" />
                            ))}
                            {/* <LabelList dataKey="value" content={renderCustomLabel} /> */}
                        </Bar>


                        {/* barra dos dados anteriores */}
                        {/* <Bar
                            radius={[0, 5, 5, 0]}
                            dataKey={`old_${dataKey_X}`}
                            // barSize={barheight}
                            label={renderCustomBarLabelLeft}
                        >
                            {chartData.map((entry, index) => (
                                //Configuração da barra
                                <Cell key={`cell-200`} fill="rgba(170, 169, 169, 0.59)" />
                            ))}
                        </Bar> */}



                        {(target && target > 0) &&
                            <ReferenceLine
                                x={formatTarget(target).ms || 0}
                                stroke="#73ff00ff"
                                strokeWidth={3}
                                label={<CustomReferenceLabel color="#73ff00ff" label={`Meta: ${formatTarget(target).hours || '-'}`} />}
                            />
                        }

                        {(chartData?.[0]?.[`old_${dataKey_X}`]) &&
                            <ReferenceLine
                                x={chartData[0][`old_${dataKey_X}`] || 0}
                                stroke="#5e5e5eff"
                                strokeWidth={3}
                                label={<CustomReferenceLabel color="#5e5e5eff" label={`Mês anterior ${msToTime(chartData[0][`old_${dataKey_X}`]).str}`} position="bottom" />}
                            />
                        }
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}



const TME_TMA = ({ periodo = false, tmetma = { tme: 0, tma: 0 } }) => {
    const [chartData, setChartData] = useState([
        // { label: "equipe", tma: 0, tme: 0 }
        // Mais dados conforme necessário
    ]);

    const maintainAspectRatio = false
    const fontSizeYaxis = 19
    const fontSizeXaxis = 13
    const fontSizeBar = 14
    const fontSizeToolTip = 16
    const chartHeight = 120//380
    const barheight = 50//100
    const cardWidth = '49%'

    const truncateString = (str, maxLength) => {
        if (str.length > maxLength) {
            return str.slice(0, maxLength - 3) + "...";
        }
        return str;
    }

    const renderCustomLabel = (props) => {
        const { x, y, width, height, value } = props;
        const textColor = '#000'//'white'//value > 41 ? 'white' : '#000';
        return (
            <text x={x + width / 2} y={y + height / 2} dy={5} fill={textColor} textAnchor="middle" font-weight="bold" font-size="smaller">
                {value}
            </text>
        );
    };

    const CustomTick_YAxis = (props) => {
        // console.log(Object.keys(props), 'height::   ' + props.height, props)
        const { x, y, payload, height, width } = props;

        return (
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={0 - chartData.length}
                    dy={16}
                    textAnchor="end"
                    verticalAnchor="middle"
                    fill="#0c51dab4"//"#666"
                    // font-size="6px"
                    style={{ fontSize: `${fontSizeYaxis}px` }}
                >
                    {truncateString(payload.value, 16)}
                </text>
            </g>
        );
    };

    const CustomTick_XAxis = (props) => {
        // console.log(Object.keys(props), 'height::   ' + props.height, props)
        const { x = 0, y = 0, payload } = props;
        const time = msToTime(payload.value)
        return (
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={0}
                    dy={16}
                    textAnchor="middle"
                    fill="#0c51dab4"//"#666"
                    style={{ fontSize: `${fontSizeXaxis}px` }}
                >
                    {/* {payload.value} */}
                    {`${time.horas}:${time.minutos}`}
                </text>
            </g>
        );
    };

    const CustomTooltip = ({ active, payload, label, prefix = '' }) => {
        if (active && payload && payload.length) {
            const time = msToTime(payload[0].value)
            return (
                <div className="custom-tooltip" style={{ backgroundColor: '#fff', borderRadius: 5, padding: '10px', border: '1px solid #ccc' }}>
                    <p className="label" style={{ fontSize: fontSizeToolTip }}>{label}</p>
                    <p className="value" style={{ fontSize: fontSizeToolTip }}>{`${prefix}${time.horas}:${time.minutos}:${time.segundos}`}</p>
                </div>
            );
        }

        return null;
    };

    const renderCustomBarLabelRight = ({ x = 0, y = 0, width, height = 10, index, value = 0 }) => {
        const textColor = '#fff';
        const time = msToTime(value)
        return (
            <text
                x={width}//{x + 5} //{x + width / 2}
                y={y + height / 2}
                dy={5}
                fill={textColor}
                font-weight="bold"
                style={{ fontSize: `${fontSizeBar}px` }}
            >
                {`${time.horas}:${time.minutos}:${time.segundos}`}
            </text>
        );
    };

    const renderCustomBarLabelLeft = ({ x = 0, y = 0, width, height = 10, index, value = 0 }) => {
        const textColor = '#fff';
        const time = msToTime(value)
        return (
            <text
                x={x + 5} //{x + width / 2}
                y={y + height / 2}
                dy={5}
                fill={textColor}
                font-weight="bold"
                style={{ fontSize: `${fontSizeBar}px` }}
            >
                {`${time.horas}:${time.minutos}:${time.segundos}`}
            </text>
        );
    };

    const getPeriod = (_period) => {
        const date = new Date(`${_period.ano}-${String((parseInt(_period.mes))).padStart(2, '0')}-01 00:00:00`);
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return ({
            ds: `${firstDay.toLocaleDateString('en-CA')}`,
            de: `${lastDay.toLocaleDateString('en-CA')}`
        })
    }

    const processData = async (ds, de) => {
        const databd = (ds && de) ? await api_bd_nr(`/reports/gettmranking/${ds}/${de}`) : { data: {} };
        // console.log('databd::::', databd)

        const proccessTMETMA = (_data) => {
            let arrData = []
            for (let k in _data) {
                arrData.push({
                    id: k,
                    ..._data[k]
                })
            }

            arrData = arrData.sort((a, b) => b.mtme - a.mtme)//.filter(el => 'name' in el)

            const sumData = arrData.reduce((acc, item) => {
                acc['tma'] += item.mtma
                acc['tme'] += item.mtme
                acc['counter'] += 1
                return acc
            }, { tma: 0, tme: 0, old_tma: 0, old_tme: 0, counter: 0, name: "Mês atual", key: 'bar-1' })

            sumData.tme = sumData.tme / sumData.counter
            sumData.tma = sumData.tma / sumData.counter

            return ([sumData])
        }

        if (Object.keys(databd?.data?.actualMonth)?.length > 0) {
            const tmetmaActualMonth = proccessTMETMA(databd?.data?.actualMonth)

            
            const tmetmaPreviousMonth = proccessTMETMA(databd?.data?.previousMonth)

            console.log('tmetmaPreviousMonth:: ',tmetmaPreviousMonth)

            tmetmaActualMonth[0]['old_tma'] = tmetmaPreviousMonth[0].tma
            tmetmaActualMonth[0]['old_tme'] = tmetmaPreviousMonth[0].tme
         

            setChartData(tmetmaActualMonth)
        }

    };

    // useState(() => processData(ds, de), [data]);

    useEffect(() => {
        (async () => {
            const { ds, de } = periodo ? getPeriod(periodo) : { ds: false, de: false }
            await processData(ds, de)
        })()
    }, [periodo?.mes, periodo?.ano])

    // console.log(periodo)
    // console.log('getPeriod', getPeriod(periodo))

    const propsChartTME = {
        chartData,
        CustomTick_XAxis,
        CustomTick_YAxis,
        barheight,
        renderCustomLabel,
        renderCustomBarLabelRight,
        renderCustomBarLabelLeft,
        CustomTooltip,
        prefix: 'TME: ',
        dataKey_X: 'tme',
        title: 'TME',
        cardHeight: chartHeight,
        target: tmetma.tme
    }

    const propsChartTMA = {
        chartData,
        CustomTick_XAxis,
        CustomTick_YAxis,
        barheight,
        renderCustomLabel,
        renderCustomBarLabelRight,
        renderCustomBarLabelLeft,
        CustomTooltip,
        prefix: 'TMA: ',
        dataKey_X: 'tma',
        title: 'TMA',
        cardHeight: chartHeight,
        target: tmetma.tma
    }

    // console.log(chartData)


    return (
        // <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: chartHeight }}>
        <div className='flex flex-row items-center justify-center'>
            <div style={{ width: cardWidth, maxWidth: cardWidth, display: 'flex', flexDirection: 'column' }}>
                {chartData?.length > 0 &&
                    <CustomBarChart
                        {...propsChartTME}
                    />
                }
            </div>

            <div style={{ width: cardWidth, maxWidth: cardWidth, display: 'flex', flexDirection: 'column' }}>
                {chartData?.length > 0 &&
                    <CustomBarChart
                        {...propsChartTMA}
                    />
                }
            </div>
        </div>
    );
};

export default TME_TMA;